var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("SoftSkillsMultiselect", {
    attrs: {
      title: "Soft Skills",
      value: _vm.softSkillsIdsFromDB,
      newSoftSkills: _vm.newSoftSkillsNames,
      getParentStyle: _vm.getParentContainer,
      disabled: _vm.disabled,
      max: _vm.max,
      placeholder: _vm.customSoftSkillLabel,
      companyId: _vm.companyId,
      withCustomSoftSkills: "",
    },
    on: { input: _vm.updateSoftSkillList, search: _vm.search },
    scopedSlots: _vm._u(
      [
        {
          key: "noResult",
          fn: function ({ currentSearchString }) {
            return [
              _c("span", { staticClass: "font-bold" }, [
                _vm._v(_vm._s(currentSearchString)),
              ]),
              _vm._v(" - is already selected "),
            ]
          },
        },
        {
          key: "option",
          fn: function ({ option: softSkill, newSoftSkill }) {
            return [
              newSoftSkill
                ? _c("SoftSkillMultiselectItem", {
                    attrs: {
                      labelText: _vm.newSoftSkillLabel,
                      softSkillName: softSkill.name,
                    },
                  })
                : _vm._e(),
              _vm._t("default", null, { softSkill: softSkill }),
            ]
          },
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }